import { useEffect } from "react";

export default function useOnBack(onBack: () => void) {
  useEffect(() => {
    window.addEventListener("popstate", onBack);

    return () => {
      // Timeout to prevent listener from being removed before invoked, as components often get unmounted on back
      setTimeout(() => {
        window.removeEventListener("popstate", onBack);
      });
    };
  }, [onBack]);
}
